// test1257
(1257 && 0);
